import UnitOfWorkService from '@/services/UnitOfWorkService'
import router from '@/router.js'
import ability from '@/plugins/abilityPlugIn'
import defineAbilitiesFor from '@/plugins/ability'
import jwtManager from '@/store/jwt'

const state = {
    token: jwtManager.getJwt(),
    username: jwtManager.getJwtSubject()
}

const getters = {
    username: state => state.username,
    isAuthenticated: state => !!state.token
}

const actions = {
    login({
        commit
    }, payload) {
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            new UnitOfWorkService().authService().login(payload).then(resp => {
                    commit('login', resp.data)
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    logout({
        commit
    }) {
        commit('logout')
    },

    checkAuthentification({
        commit
    }) {
        if (jwtManager.getJwt() == null || jwtManager.jwtExpired() == true) {
            commit('logout')
            return
        }

        return new Promise((resolve, reject) => {
            new UnitOfWorkService().authService().authorized().then(() => {
                    ability.update(defineAbilitiesFor(jwtManager.getJwtRoles()))
                    resolve()
                })
                .catch(err => {
                    commit('logout')
                    reject(err)
                })
        })
    }
}

const mutations = {
    login(state, jwt) {
        jwtManager.setJwt(jwt)
        state.token = jwt
        state.username = jwtManager.getJwtSubject()
        ability.update(defineAbilitiesFor(jwtManager.getJwtRoles()))
    },
    logout() {
        jwtManager.removeJwt()
        state.token = null
        state.username = null
        ability.update(defineAbilitiesFor(''))
        router.push({
            path: '/login'
        })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}